<h1 mat-dialog-title>{{ data }} already exist.</h1>

<div mat-dialog-content>Do you want to drop it and generate it again?</div>

<div mat-dialog-actions>
  <button class="btn-product" [mat-dialog-close]="true" style="margin-right: 10px; margin-left: 10px;">Drop and recreate</button>
  <button class="btn-product" [mat-dialog-close]="false" style="margin-right: 10px; margin-left: 10px;">Cancel</button>
</div>
